module.exports = __webpack_public_path__ + "img/5.bddb4fca.png";